import { BrandLogo } from '@components/Brand/BrandLogo';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { NoddiBasicCard } from 'noddi-ui-web';
import type { ReactNode } from 'react';

type Props = {
  title: string;
  children: ReactNode;
};

export const LoginCard = ({ title, children }: Props) => (
  <ContentWrapperCustomerApp className='mx-auto min-h-[80vh] max-w-xl justify-center'>
    <NoddiBasicCard className='flex flex-col gap-5'>
      <div className='flex items-center justify-between gap-4'>
        <h1 className='text-xl font-semibold'>{title}</h1>
        <BrandLogo />
      </div>
      {children}
    </NoddiBasicCard>
  </ContentWrapperCustomerApp>
);
